export default {
  labels: {
    signed_by: 'Firmado por {{name}} el {{date}}',
    signed_by_no_date: 'Firmado por {{name}}',
  },
  buttons: {
    retry: 'Reintentar',
  },
  errors: {
    load_failed: 'No se pudo cargar el contrato. Comprueba tu conexión e inténtalo de nuevo.',
  },
};
